import axios from 'axios';
import {
    Message,
    Modal
} from 'iview'
import cache from "../plugins/cache";
import store from '../store/index'
import router from "../router";

let baseURLStr = window.g.ApiUrl;
axios.defaults.baseURL = baseURLStr;

//请求拦截器
axios.interceptors.request.use(config => {
    let token = localStorage.getItem('token');
    if (token) {
        config['headers']['common']['Authorization'] = token;
    }
    // if (
    //     config.method === "post" || config.method === "put"
    // ){
    //     const requestObj = {
    //         url: config.url,
    //         data:
    //             typeof config.data === "object"
    //                 ? JSON.stringify(config.data)
    //                 : config.data,
    //         time: new Date().getTime(),
    //     };
    //     const sessionObj = cache.session.getJSON("sessionObj");
    //     if (
    //         sessionObj === undefined ||
    //         sessionObj === null ||
    //         sessionObj === ""
    //     ) {
    //         cache.session.setJSON("sessionObj", requestObj);
    //     } else {
    //         const s_url = sessionObj.url; // 请求地址
    //         const s_data = sessionObj.data; // 请求数据
    //         const s_time = sessionObj.time; // 请求时间
    //         const interval = 1000; // 间隔时间(ms)，小于此时间视为重复提交
    //         if (
    //             s_data === requestObj.data &&
    //             requestObj.time - s_time < interval &&
    //             s_url === requestObj.url
    //         ) {
    //             const message = "数据正在处理，请勿重复提交";
    //             console.warn(`[${s_url}]: ` + message);
    //             Modal.warning({
    //                 title: "提示信息",
    //                 content: message,
    //                 okText: "关闭",
    //             });
    //             return Promise.reject(new Error(message));
    //         } else {
    //             cache.session.setJSON("sessionObj", requestObj);
    //         }
    //     }
    // }

    return config
});
//相应拦截器
axios.interceptors.response.use(response => {
    console.log('response.data.code',response.data.code)
    if (response.data.code == 200) {
        return response.data;
    }  else if(response.data.code == 403) {
        let isRelogin = {
            show: false
        };
        if (isRelogin.show) {
            return;
        } else {
            isRelogin.show = true;
        }
        setTimeout(() => {
            Modal.warning({
                title: "提示信息",
                content: response.data.msg,
                okText: "关闭",
                onOk: () => {
                    let continueCert = localStorage.getItem('continueCert')&&JSON.parse(localStorage.getItem('continueCert'));
                    localStorage.clear();
                    if(continueCert){
                        localStorage.setItem('continueCert',JSON.stringify(continueCert))
                    }
                    store.dispatch("setUserInfo", "");
                    router.push({
                        path: '/index/Login'
                    });
                }
            });
        }, 300)
    }else
    {
    setTimeout(() => {
        Modal.warning({
            title: "提示信息",
            content: response.data.msg,
            okText: "关闭",
        });
    }, 300)
    }
});

export default axios



// WEBPACK FOOTER //
// ./src/api/index.js